module.exports = __webpack_public_path__ + "img/viadukt.5e4942fe.jpg";